import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const ChannelFilterButtonsContainer = styled.div<{ focused?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-right: ${8 * ScreenUtils.widthRatio}px;
`;

export default withAnimation(ChannelFilterButtonsContainer);
